
import { RevButton } from '@ds/components/Button'
import { RevButtonRounded } from '@ds/components/ButtonRounded'
import { RevModal } from '@ds/components/Modal'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconCross } from '@ds/icons/IconCross'
import isEmpty from 'lodash/isEmpty'

import { MODAL_NAMES } from '@config/constants'
import RecommendationCrossSell from '@recommendation/components/RecommendationCrossSell/RecommendationCrossSell.vue'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import translations from './AddToCartModal.translations'

export default {
  components: {
    IconCheckInCircle,
    RecommendationCrossSell,
    RevButton,
    RevButtonRounded,
    RevModal,
  },

  props: {
    accessories: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    listingId: {
      type: Number,
      required: true,
    },

    additionalListings: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,

    IconCross: () => IconCross,

    modalName: () => MODAL_NAMES.PRODUCT.ADD_TO_CART,

    headerTitle() {
      return this.$t(this.translations.title, {
        count: [this.listingId, ...this.additionalListings].length,
        product: this.title,
      })
    },

    formattedAccessories() {
      return this.accessories
        .map(({ text }) => text)
        .filter((text) => !isEmpty(text))
        .join(', ')
    },
  },
  methods: {
    handleAddToCartRedirect() {
      trackClick({
        name: 'go_to_cart',
        zone: 'add_to_cart_modal',
      })

      this.$navigation.push({
        type: 'internal',
        name: ROUTES.CHECKOUT.CART,
      })
    },

    handleClose(close) {
      trackClick({
        name: 'continue_shopping',
        zone: 'add_to_cart_modal',
      })

      this.$emit('close')
      if (close) {
        close()
      }
    },
  },
}
